import { render, staticRenderFns } from "./CreditRedeem.vue?vue&type=template&id=35d2f132"
import script from "./CreditRedeem.vue?vue&type=script&lang=js"
export * from "./CreditRedeem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports